import { render } from "./WSpinner.vue?vue&type=template&id=ed025fc8"
import script from "./WSpinner.vue?vue&type=script&lang=js"
export * from "./WSpinner.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__